import {fetch} from '@/utils/fetch';

/**
 *订单总数、订单统计、预警统计表接口
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function getHome() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/get-orders-count`,
    method: 'get',
  });
}
/**
 *销售排行统计
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function findTopTenSales() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/get-ten-sales`,
    method: 'get',
  });
}
/**
 *订单年度统计
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function getYearOrders() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/get-year-orders`,
    method: 'get',
  });
}

/**
 *订单总行数、取消行数、下发、拣货、复核、发货等
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function getDateOrderLines() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/get-date-orderlines`,
    method: 'get',
  });
}

/**
 *月订单出库率
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function getMOnthCheckOutRate() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/month-check-out-rate`,
    method: 'get',
  });
}

/**
 *首页地图数据
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function getMapDatas() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/get-map-datas`,
    method: 'get',
  });
}


/**
 *报表管理：在途行数统计
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function getSendCount() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/get-send-count`,
    method: 'get',
  });
}
